import "core-js/modules/es.symbol.js";
import "core-js/modules/es.array.filter.js";
import "core-js/modules/es.object.get-own-property-descriptor.js";
import "core-js/modules/es.object.get-own-property-descriptors.js";
import "core-js/modules/es.object.keys.js";
import "core-js/modules/es.object.to-string.js";
import "core-js/modules/web.dom-collections.for-each.js";
import _defineProperty from "@babel/runtime/helpers/defineProperty";
import _objectWithoutProperties from "@babel/runtime/helpers/objectWithoutProperties";
var _excluded = ["showScore", "showGraph", "score", "change", "title", "emptyMessage", "to", "chartData", "chartLabels", "selectedValue", "chartHeight", "options", "getTooltipReadout", "showAllLabels", "chartLabelClicks", "screenContext"];
function ownKeys(e, r) { var t = Object.keys(e); if (Object.getOwnPropertySymbols) { var o = Object.getOwnPropertySymbols(e); r && (o = o.filter(function (r) { return Object.getOwnPropertyDescriptor(e, r).enumerable; })), t.push.apply(t, o); } return t; }
function _objectSpread(e) { for (var r = 1; r < arguments.length; r++) { var t = null != arguments[r] ? arguments[r] : {}; r % 2 ? ownKeys(Object(t), !0).forEach(function (r) { _defineProperty(e, r, t[r]); }) : Object.getOwnPropertyDescriptors ? Object.defineProperties(e, Object.getOwnPropertyDescriptors(t)) : ownKeys(Object(t)).forEach(function (r) { Object.defineProperty(e, r, Object.getOwnPropertyDescriptor(t, r)); }); } return e; }
import React from 'react';
import { Link } from 'react-router-dom';
import useUniqueId from 'hooks/useUniqueId';
import useVisibleScreenContext from 'hooks/useVisibleScreenContext';
import getLocalisedDate from 'utils/dates/getLocalisedDate';
import Card from 'components/Card';
import Text from 'components/Text';
import Icon from 'components/Icon';
import Heading from 'components/Heading';
import TextLink from 'components/TextLink';
import Flex, { Box } from 'components/Flex';
import TrendIndicator from 'components/TrendIndicator';
import { ChartWithPoints } from 'components/Charts';
import { jsx as _jsx, jsxs as _jsxs } from "react/jsx-runtime";
function GraphCard(_ref) {
  var _ref$showScore = _ref.showScore,
    showScore = _ref$showScore === void 0 ? true : _ref$showScore,
    _ref$showGraph = _ref.showGraph,
    showGraph = _ref$showGraph === void 0 ? true : _ref$showGraph,
    score = _ref.score,
    change = _ref.change,
    title = _ref.title,
    emptyMessage = _ref.emptyMessage,
    to = _ref.to,
    _ref$chartData = _ref.chartData,
    chartData = _ref$chartData === void 0 ? [] : _ref$chartData,
    _ref$chartLabels = _ref.chartLabels,
    chartLabels = _ref$chartLabels === void 0 ? [] : _ref$chartLabels,
    selectedValue = _ref.selectedValue,
    chartHeight = _ref.chartHeight,
    options = _ref.options,
    getTooltipReadout = _ref.getTooltipReadout,
    showAllLabels = _ref.showAllLabels,
    chartLabelClicks = _ref.chartLabelClicks,
    screenContext = _ref.screenContext,
    otherProps = _objectWithoutProperties(_ref, _excluded);
  var titleId = useUniqueId();
  var watchedElementRef = useVisibleScreenContext(screenContext !== null && screenContext !== void 0 ? screenContext : null);
  var selected = selectedValue ? getLocalisedDate({
    date: selectedValue,
    options: {
      month: 'short',
      day: 'numeric'
    }
  }) : null;
  var hasScore = score !== undefined && score !== null;
  var minimumDataPoints = 1; // Minimum data points required to display the chart

  return /*#__PURE__*/_jsx(Card, {
    ref: watchedElementRef,
    role: "region",
    "aria-labelledby": titleId,
    children: /*#__PURE__*/_jsxs(Flex, {
      column: true,
      align: "stretch",
      height: "100%",
      gap: "xs",
      children: [/*#__PURE__*/_jsxs(Box, {
        py: "s",
        px: "m",
        children: [/*#__PURE__*/_jsx(Heading, {
          as: "h3",
          id: titleId,
          children: to ? /*#__PURE__*/_jsx(TextLink, {
            stealthy: true,
            as: Link,
            to: to,
            children: /*#__PURE__*/_jsxs(Flex, {
              justifyContent: "space-between",
              gap: "xs",
              alignItems: "top",
              children: [title, /*#__PURE__*/_jsx(Icon, {
                color: "links",
                name: "arrow-right",
                size: "unscaled",
                ml: "xs"
              })]
            })
          }) : title
        }), /*#__PURE__*/_jsxs(Flex, {
          align: "top",
          mt: "xs",
          gap: "xxs",
          children: [showScore && (hasScore ? /*#__PURE__*/_jsxs(Text, {
            bold: true,
            fontSize: "xxl",
            children: [score, /*#__PURE__*/_jsx(Text, {
              fontSize: "xxs",
              children: "%"
            })]
          }) : /*#__PURE__*/_jsx(Text, {
            bold: true,
            fontSize: "xxl",
            dimmed: true,
            children: "-"
          })), !!change && /*#__PURE__*/_jsx(TrendIndicator, {
            size: "s",
            value: change
          })]
        })]
      }), showGraph && /*#__PURE__*/_jsx(Box, _objectSpread(_objectSpread({
        mt: "auto",
        px: "s"
        // Ensure all the labels are visible on x-axis
        ,
        mr: "xs"
      }, otherProps), {}, {
        children: /*#__PURE__*/_jsx(ChartWithPoints, {
          emptyMessage: emptyMessage,
          data: chartData,
          minimumDataPoints: minimumDataPoints,
          labels: chartLabels,
          labelClicks: chartLabelClicks,
          selectedValue: selected,
          getTooltipReadout: getTooltipReadout,
          chartHeight: chartHeight,
          options: options,
          showAllLabels: showAllLabels
        })
      }))]
    })
  });
}
export default GraphCard;